import { useState, useEffect } from 'react'

const checkDimensions = () => {
  let windowWidth = typeof window !== 'undefined' ? window.innerWidth : 0
  let windowHeight = typeof window !== 'undefined' ? window.innerHeight : 0
  
  return { windowWidth, windowHeight }
}

const getSize = windowWidth => {
  if (windowWidth < 700){
    return 'mobile'
  }
  if (windowWidth > 700 && windowWidth < 1000){
    return 'small'
  }
  else {
    return 'large'
  }
}
  
const useBreakpoint = () => {
  let [breakpoint,setBreakpoint] = useState(getSize(checkDimensions().windowWidth))

  useEffect(() => {
    let timeoutId = null
    const resizeListener = () => {
      clearTimeout(timeoutId)
      timeoutId = setTimeout(() => setBreakpoint(getSize(checkDimensions().windowWidth)), 20)
    }
    window.addEventListener('resize', resizeListener)
    return () => {
      window.removeEventListener('resize', resizeListener)
    }
  }, [breakpoint])

  return [breakpoint]
}

export default useBreakpoint